import { render, staticRenderFns } from "./ProductoCategoriaCreate.vue?vue&type=template&id=fb797cba&scoped=true&"
import script from "./ProductoCategoriaCreate.vue?vue&type=script&lang=js&"
export * from "./ProductoCategoriaCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb797cba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VDialog})
